import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { handleKeyPress } from '../../../utilities/keyHandler'

const scope = 'TagBar'
export default class TagBar extends Component {
  static propTypes = {
    title: PropTypes.string,
    tags: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    inline: PropTypes.bool,
  }

  render() {
    const { className, title, tags, onRemove, inline } = this.props
    return (
      <div className={classnames(scope, inline && `${scope}_Inline`, className)}>
        <div className={classnames(`${scope}-Title`)}>{title}</div>
        <div className={classnames(`${scope}-Tags`)}>
          {tags.map(tag => (
            <div
              key={tag.id}
              className={classnames(`${scope}-Tag`)}
              onClick={() => onRemove(tag.id)}
              title={`Remove ${tag.text} Tag`}
              tabIndex={0}
              onKeyPress={ev => handleKeyPress(ev, () => onRemove(tag.id))}
            >
              <i className='fa fa-tag' />
              {tag.text}
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/tag-bar/tag-bar.jsx